import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ChartsService } from '@shared/services/charts.service';

@Component({
  standalone: false,
  selector: 'gstar-tax-impact-map',
  templateUrl: './tax-impact-map.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxImpactMapComponent implements OnInit {
  chartService = inject(ChartsService);

  destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.chartService.taxJurisdictionByFilters$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
